import { NameValue } from './NameValue'

export const StyleForm = [NameValue('Specified', 0), NameValue('Form Based', 1)]
